import Vue from 'vue';
import VueFragment from 'vue-fragment';

Vue.use(VueFragment.Plugin);
